import { QueryClientProvider } from '@tanstack/react-query';
import type { FunctionComponent } from 'react';
import queryClient from './client';

/**
 * Makes react-query available to the app.
 */
export const ReactQueryProvider: FunctionComponent = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    {children}
  </QueryClientProvider>
);

export default ReactQueryProvider;
